class SocialModule extends HTMLElement {
    constructor() {
      super();
      this.splideOptions = {
        gap: 0,
        type: 'loop',
        gap: 36,
        perPage: 4,
        perMove: 1,
        pagination: false,
        breakpoints : {
          990: {
            perPage:0,
            perMove:0,
            autoWidth:true,
            type: 'slide'
          }
        }
      }
      
      this.socialModule = new Splide(this.querySelector('.splide'), this.splideOptions);
      this.socialModule.mount();
      this.socialModule.on('updated', () => {
        this.socialModule.refresh();
      })
    }
}
customElements.define('social-module', SocialModule);